$( "#register" ).click(function() {

    $( "#registration-company-form" ).stop(true, true)
    .animate({
        height:"toggle",
        opacity:"toggle"
    },1000); 

    $( "#register" ).fadeOut("fast");
    $( "#driver" ).fadeIn("fast");
    $( "#registration-driver-form" ).hide();

  });

  $( "#driver" ).click(function() {
    
    $('#registration-driver-form').stop(true, true)
    .animate({
        height:"toggle",
        opacity:"toggle"
    },1000); 

    $( "#driver" ).fadeOut("fast");
    $( "#register" ).fadeIn("fast");
    $( "#registration-company-form" ).hide();

  });


// WEBPACK FOOTER //
// ./resources/assets/js/register.js